import { postData, getData, patchData, deleteData } from 'src/utils/axios';
import { urlMap } from 'src/utils/urls';

export const getTeleHealthPackages = async (clinicId) => {
  const url = `${urlMap.telehealth.list.replace('{clinicId}', clinicId)}`;
  return getData(url);
};

export const addTeleHealthPackage = async (therapyData) => {
  const url = `${urlMap.telehealth.create}`;
  return postData(url, therapyData);
};

export const deleteTeleHealthTherapy = async (therapyId, clinicId) => {
  const url = `${urlMap.telehealth.delete.replace(':therapyId', therapyId)}?clinic_id=${clinicId}`;
  return deleteData(url);
};

export const getTeleHealthTherapyDetails = async (therapyId, clinicId) => {
  const url = `${urlMap.telehealth.getDetails.replace(':therapyId', therapyId)}?clinicId=${encodeURIComponent(clinicId)}`;
  return getData(url);
};

export const updateTeleHealthTherapy = async (therapyId, therapyData) => {
  const url = `${urlMap.telehealth.update.replace(':therapyId', therapyId)}?clinic_id=${therapyData.clinic_id}`;
  return patchData(url, therapyData);
};

export const toggleTeleHealthTherapy = async (therapyId, clinicId, data) => {
  const baseUrl = urlMap.telehealth.update.replace(':therapyId', therapyId);
  const url = `${baseUrl}?clinic_id=${clinicId}`;
  return patchData(url, data);
};

export const getTeleHealthTherapyCategories = async () => {
  const url = urlMap.telehealth.categories;
  return getData(url);
};

export const searchTeleHealthTherapies = async (name) => {

  const url = `${urlMap.telehealth.search}?name=${name}`;
  return getData(url);
};
